module.exports = __webpack_public_path__ + "static/media/message_outgoing.8d4bd822.svg";